import type { QueueFilterName, QueueFilter } from './types';

export const queueFilterEnum: Record<QueueFilterName, QueueFilter> = {
    ALL_POLICE: {
        assignmentStatus: 'ALL',
        queueClass: 'POLICE',
    },
    ALL_FIRE: {
        assignmentStatus: 'ALL',
        queueClass: 'FIRE',
    },
    ALL_EMS: {
        assignmentStatus: 'ALL',
        queueClass: 'MEDICAL',
    },
    POLICE_ASSIGNED: {
        assignmentStatus: 'ASSIGNED',
        queueClass: 'POLICE',
    },
    FIRE_ASSIGNED: {
        assignmentStatus: 'ASSIGNED',
        queueClass: 'FIRE',
    },
    EMS_ASSIGNED: {
        assignmentStatus: 'ASSIGNED',
        queueClass: 'MEDICAL',
    },
    POLICE_UNASSIGNED: {
        assignmentStatus: 'UNASSIGNED',
        queueClass: 'POLICE',
    },
    FIRE_UNASSIGNED: {
        assignmentStatus: 'UNASSIGNED',
        queueClass: 'FIRE',
    },
    EMS_UNASSIGNED: {
        assignmentStatus: 'UNASSIGNED',
        queueClass: 'MEDICAL',
    },
} as const;
